import { createSelector } from 'reselect';

// Sélecteur pour obtenir les positions depuis le store
const EMPTY_ARRAY = [];
const selectLastPositions = state => state.map?.lastPositions?.value?.features ?? EMPTY_ARRAY;

// Sélecteur pour compter les alertes (URGENCY_LEVEL 3)
export const selectUrgencyLevel3Features = createSelector(
  [selectLastPositions],
  (lastPositions) => lastPositions.filter(f => f.properties.URGENCY_LEVEL === "3")
);

export const selectMapAlertCount = createSelector(
  [selectUrgencyLevel3Features],
  (filtered) => filtered.length
);

// Sélecteur pour compter les stops (URGENCY_LEVEL 4)
export const selectUrgencyLevel4Features = createSelector(
  [selectLastPositions],
  (lastPositions) => lastPositions.filter(f => f.properties.URGENCY_LEVEL === "4")
);

export const selectMapStopCount = createSelector(
  [selectUrgencyLevel4Features],
  (filtered) => filtered.length
);

// Sélecteur pour compter le total de bus
export const selectMapTotalBusCount = createSelector(
  [selectLastPositions],
  (lastPositions) => lastPositions.length
);

// Sélecteur qui regroupe les données par type et par niveau d'alerte
export const selectLayeredData = createSelector(
  (state) => state.map.lastPositions,
  (state) => state.map.poi,
  (lastPositions, poi) => {
    const busesByUrgency = {
      level3: [],
      level4: [],
    };

    if (lastPositions && lastPositions.value && lastPositions.value.features) {
      lastPositions.value.features.forEach(position => {
        if (position.properties.URGENCY_LEVEL === "3") {
          busesByUrgency.level3.push(position);
        } else if (position.properties.URGENCY_LEVEL === "4") {
          busesByUrgency.level4.push(position);
        }
      });
    }

    const poiByType = {
      depots: [],
      dealerships: [],
      pantographs: [],
    };

    if (poi && poi.features) {
      poi.features.forEach(poiItem => {
        switch (poiItem.properties.TYPE_STATIC) {
          case "depot":
            poiByType.depots.push(poiItem);
            break;
          case "dealer":
            poiByType.dealerships.push(poiItem);
            break;
          case "charger":
          case "pantograph":
            poiByType.pantographs.push(poiItem);
            break;
          default:
            break;
        }
      });
    }

    return { busesByUrgency, poiByType };
  }
);